import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';

import { Report } from '~/components';
import { DateTime, Autocomplete, Input, RadioGroup } from '~/components/Form';

//import { GFO, GFU, GPP, GPPEM } from '~/constants/perfil';

import * as Yup from 'yup';
import { t, parseDateString } from '~/helpers';
import { GFO } from '~/constants/perfil';

function Relanaliticodadespesa() {
  const [open, setOpen] = useState(true);

  //NOVOS CAMPOS
  const [valueOrgao, setValueOrgao] = React.useState();
  const [inputValueOrgao, setInputValueOrgao] = React.useState('');

  const [valueUnidade, setValueUnidade] = React.useState(0);
  const [inputValueUnidade, setInputValueUnidade] = React.useState('');

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const { profile } = useSelector((state) => state.user);

  const [disableOrgao, setDisableOrgao] = useState(false);

  const [orgaoRequired, setOrgaoRequired] = useState(true);

  async function handleValidate(param) {
    try {
      const schema = Yup.object().shape({
        datahorainicial: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio')),
        datahorafinal: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(
            datahorafinal,
            `A data não pode ser superior a ${datahorafinal}`
          )
          .min(
            Yup.ref('datahorainicial'),
            'A data não pode ser inferior a Data inicial'
          ),
        orga_codigo: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
      });

      // orga_codigo: orgaoRequired
      // ? Yup.string()
      //   .required(t('s.geral.validacao.campoobrigatorio'))
      // : Yup.string()
      // .required(t('s.geral.validacao.campoobrigatorio')),

      await schema.validate(param, {
        abortEarly: false,
      });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      if (profile.glousuariotipo === GFO) {
        setValueOrgao(profile.glousuarioorgacodigo);
        setDisableOrgao(true);
        setOrgaoRequired(false);
      }
    }

    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  function handleSerializeForm(params) {
    const { datahorainicial, datahorafinal } = params;

    let orgao = '0';

    if (params.orga_codigo) {
      orgao = params.orga_codigo;
    }

    let orgaostr = '';

    if (params.orga_nome) {
      orgaostr = params.orga_nome;
    }

    let unidade = 0;
    let unidadestr = '';
    let placa = '';
    let produto = '';
    let produtostr = '';
    let agrupamento = 1;

    let tipo = 'pdf';

    if (params.formato) {
      tipo = params.formato;
    }

    return {
      ...params,
      datahorainicial,
      datahorafinal,
      orgao,
      orgaostr,
      unidade,
      unidadestr,
      placa,
      produto,
      produtostr,
      agrupamento,
      tipo,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Relatório Analítico da Despesa"
      relatorio="rel31orgaoanaliticodespesa"
      validate={(param) => handleValidate(param)}
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial,
        datahorafinal,
        orga_codigo: valueOrgao,
      }}
    >
      <DateTime time label="Data Inicial" name="datahorainicial" />

      <DateTime time label="Data Final" name="datahorafinal" />

      <Autocomplete
        name="orga_codigo"
        label="orga_nome"
        title="Órgão"
        id="orga_codigo"
        url="orgaos"
        unique="orga_codigo"
        value={valueOrgao}
        inputValue={inputValueOrgao}
        onChange={(event, newValue) => {
          setValueOrgao(newValue);
        }}
        onInputChange={(event, newInputValueOrgao) => {
          setInputValueOrgao(newInputValueOrgao);
        }}
        defaultValue=""
        hiddens={[{ name: 'orga_nome' }]}
        getValue={(value) => {
          setValueUnidade(0);
          setInputValueUnidade('');
          if (value.orga_codigo !== null) {
            setValueOrgao(value.orga_codigo);
          } else {
            setValueOrgao();
          }
        }}
        disabled={disableOrgao}
      />

      <RadioGroup
        name="formato"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relanaliticodadespesa;
